<div class="p8-bdc_settings__container">
  <mat-drawer-container>
    <mat-drawer [mode]="sidenavMode" [opened]="opened">
      <mat-list>
        <div class="p8-bdc-settings_link__category p8-secondary p8-medium">BANQUE DE CONNAISSANCE</div>
        <mat-divider></mat-divider>
        <mat-list-item *ngFor="let list of lists">
          <mat-icon routerLinkActive="active" matListItemIcon color="primary">{{list.icon}}</mat-icon>
          <span mat-line routerLinkActive="active" [routerLink]="list.url" style="cursor: pointer">{{list.title}}</span>
        </mat-list-item>
      </mat-list>
    </mat-drawer>

    <mat-drawer-content>
      <div class="p8-bdc_settings__content-container mat-typography">
        <div class="p8-bdc_settings__content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>

